import React, { Component } from 'react'
import { Grid, ButtonGroup, Button } from '@material-ui/core'

class Header extends Component {
    constructor(props) {
      super(props);
      this.handleClick.bind(this);
    }
    handleClick(param) {
      this.props.setCurrent(param);
    }
    render() {
      return(
        <Grid item >
          <ButtonGroup variant='contained' color='secondary' fullWidth>
              <Button onClick={()=>{this.handleClick('Resume')}}>Resume</Button>
              <Button onClick={()=>{this.handleClick('Portfolio')}}>Portofolio</Button>
              <Button onClick={()=>{this.handleClick('Contact')}}>Contact Me</Button>
          </ButtonGroup>
        </Grid>
      );
    }
  }

  export default Header;